import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
} from "react";

import api from "../helpers/api.js";

import axios from "axios";

import Config, { token } from "../config.js";

import CustomModal from "../components/CustomModal";
import MainButton from "../components/SmallComponents/MainButton";
import ImageImportTool from "../components/ImageImportTool";

import CreateNewUserModal from "../components/Modals/CreateNewUserModal";

import * as Material from "@mui/material";

import LandscapeIcon from "@mui/icons-material/Landscape";
import MediationIcon from "@mui/icons-material/Mediation";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CloseIcon from "@mui/icons-material/Close";
import PixIcon from "@mui/icons-material/Pix";
import PaymentIcon from "@mui/icons-material/Payment";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReplayIcon from "@mui/icons-material/Replay";

import { ChallengeConfig } from "../pages/ChallengeManager";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

import PaymentCard from "../components/Modals/PaymentCard";

import QRCode from "qrcode.react";

import "./styles/challenge-context.css";

import { useAuth } from "./AuthContext.js";

const ChallengeContext = createContext({ signed: false });

export const ChallengeProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const { signed } = useAuth();

  const [challenges, setChallenges] = useState(null);
  const [currentChallenge, setCurrentChallenge] = useState(null);

  const [selectModalOpen, setSelectModalOpen] = useState(false);

  const [Modal_addUserOpen, setModal_addUserOpen] = useState(false);

  const [creationPreParams, setCreationPreParams] = useState(null);

  const [Modal_removeMemberOpen, setModal_removeMemberOpen] = useState(null);

  const [Modal_generateLinkOpen, setModal_generateLinkOpen] = useState(null);

  const [Modal_newSubscriptionOpen, setModal_newSubscriptionOpen] =
    useState(null);

  const [Modal_createChallengeOpen, setModal_createChallengeOpen] =
    useState(false);

  const [subscriptionStatus, setSubscriptionStatus] = useState("LOADING");

  useEffect(() => {
    if (loading) {
      loadChallenges();
    }
  }, [loading]);

  useEffect(() => {
    if (subscriptionStatus === "LOADING") {
      handleLoadSubscriptionStatus();
    }
  }, [subscriptionStatus]);

  async function handleLoadSubscriptionStatus() {
    try {
      const { data } = await api.get("/billing/getPlatformSubscriptionStatus");
      if (data.status === "INADIMPLENT") handleOpenSubscriptionModal();

      setSubscriptionStatus({ ...data });
    } catch (e) {
      console.log(e);
    }
  }

  async function loadChallenges() {
    try {
      let { data } = await api.get("/subaccounts");

      console.log(data);

      data = data.map((challenge) => {
        if (challenge.awards) challenge.awards = JSON.parse(challenge.awards);
        return challenge;
      });

      let Stored_currentChallenge = await localStorage.getItem(
        "@curr_challenge"
      );

      if (!Stored_currentChallenge) {
        Stored_currentChallenge = data[0];
      } else {
        Stored_currentChallenge = JSON.parse(Stored_currentChallenge);
        const freshCurrentChallenge = data.filter(
          (challenge) =>
            challenge.challenge_id == Stored_currentChallenge.challenge_id
        )[0];
        if (!freshCurrentChallenge) {
          Stored_currentChallenge = data[0];
        } else {
          Stored_currentChallenge = freshCurrentChallenge;
        }
      }

      handleStoreChallengeInLoco(Stored_currentChallenge);

      setChallenges([...data]);
      setCurrentChallenge({ ...Stored_currentChallenge });
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }

  function handleOpenSubscriptionModal() {
    setModal_newSubscriptionOpen(true);
  }

  function getSubscriptionStatus() {
    return subscriptionStatus;
  }

  function handleOpenChallengesSelect() {
    setSelectChallengeModal(true);
  }
  function handleOpenAddUsersTool(params = null) {
    if (params) setCreationPreParams({ ...params });
    setModal_addUserOpen(true);
  }
  function handleOpenRemoveMemberTool(user) {
    setModal_removeMemberOpen({ ...user });
  }
  function handleOpenGenerateLinkTool(selectedGroup = true) {
    setModal_generateLinkOpen(selectedGroup);
  }
  function handleChallengeChosen(value) {
    setSelectChallengeModal(false);
    handleStoreChallengeInLoco(value);
    setCurrentChallenge({ ...value });
  }
  function setSelectChallengeModal(value) {
    const event = new CustomEvent("toggle_select_challenge_modal", {
      detail: value,
    });
    window.dispatchEvent(event);
  }
  function handleOpenNewChallengeModal(value) {
    setModal_createChallengeOpen(true);
  }

  async function handleStoreChallengeInLoco(challenge) {
    await localStorage.setItem("@curr_challenge", JSON.stringify(challenge));
  }

  const MEMO_Children = useMemo(() => <>{children}</>, [currentChallenge]);

  return (
    <ChallengeContext.Provider
      value={{
        loading,
        setLoading,

        challenges,
        currentChallenge,

        handleOpenChallengesSelect,
        handleOpenAddUsersTool,
        handleOpenRemoveMemberTool,
        handleOpenGenerateLinkTool,
        handleOpenNewChallengeModal,
        handleOpenSubscriptionModal,

        getSubscriptionStatus,

        Modal_addUserOpen,
        Modal_removeMemberOpen,
      }}
    >
      {MEMO_Children}

      <ModalChallenges
        challenges={challenges}
        handleOpenCreate={handleOpenNewChallengeModal}
        setCurrentChallenge={handleChallengeChosen}
      />
      <CreateNewUserModal
        key={Math.random()}
        creationPreParams={creationPreParams}
        open={Modal_addUserOpen}
        setOpen={setModal_addUserOpen}
        handleCreated={() => setModal_addUserOpen(false)}
      />
      <ModalRemoveMember
        key={Math.random()}
        open={!!Modal_removeMemberOpen}
        setOpen={setModal_removeMemberOpen}
        user={Modal_removeMemberOpen}
      />
      <ModalGenerateLink
        key={Math.random()}
        open={!!Modal_generateLinkOpen}
        setOpen={setModal_generateLinkOpen}
        selectedGroup={Modal_generateLinkOpen}
      />
      <ChallengeConfigModal
        open={Modal_createChallengeOpen}
        onCreated={() => {
          setModal_createChallengeOpen(false);
          loadChallenges();
          window.navigate("/communities");
        }}
        onClose={() => setModal_createChallengeOpen(false)}
      />
      <PaymentCard
        open={Modal_newSubscriptionOpen}
        setOpen={setModal_newSubscriptionOpen}
      />
    </ChallengeContext.Provider>
  );
};

export default ChallengeContext;

export function useChallenge() {
  const context = useContext(ChallengeContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider.");
  }

  return context;
}

const ModalChallenges = ({
  setCurrentChallenge,
  challenges,
  handleOpenCreate,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleEvent = (event) => {
      setOpen(event.detail);
    };

    window.addEventListener("toggle_select_challenge_modal", handleEvent);

    return () => {
      window.removeEventListener("toggle_select_challenge_modal", handleEvent);
    };
  }, []);

  const Challenge = ({ key, info }) => (
    <>
      <div className="challenge-row" onClick={() => setCurrentChallenge(info)}>
        {info?.banner ? (
          <img src={info?.banner} className="challenge-banner" />
        ) : (
          <LandscapeIcon className="challenge-banner" />
        )}
        <h5>{info.name}</h5>
        <small>
          <em>{info.members} participantes</em>
        </small>
        <MainButton
          shadow={false}
          variant="contained"
          color="white"
          small
          onClick={() => setCurrentChallenge(info)}
          label={"Selecionar"}
        />
      </div>
      <Material.Divider />
    </>
  );
  return (
    <CustomModal
      maxWidth={500}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={false}
      title="Selecione um desafio"
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container">
          <div
            className="challenge-select-title mb-2 pt-2 px-1"
            style={{ width: "100%" }}
          >
            <h3>Seus desafios</h3>
            <MainButton
              shadow={false}
              variant="contained"
              color="white"
              small
              onClick={() => {
                setOpen(false);
                handleOpenCreate();
              }}
              label="Criar desafio"
              endIcon={<AddIcon color="primary" />}
            />
          </div>
          {challenges &&
            challenges?.map((data, i) => <Challenge key={i} info={data} />)}
        </div>
      }
      modalClass="select-challenge-modal"
      bottomButtonsOrientation="horizontal"
    />
  );
};

const ModalRemoveMember = ({ open, setOpen, user }) => {
  const [confirmText, setConfirmText] = useState();
  const [loading, setLoading] = useState(false);

  const firstName = user?.username?.split(" ")[0];

  const { currentChallenge } = useChallenge();

  async function handleRemoveUser() {
    setLoading(true);

    try {
      const result = await api.delete("challenge/members", {
        challenge_id: user.challenge_id,
        user_id: user.id,
      });

      if (result.data.success) {
        window.setSnackbar("Usuário removido com sucesso");
        setOpen(false);
        user.onDelete();
      } else {
        window.setSnackbar(
          "Houve um erro ao remover este usuário, tente novamente mais tarde"
        );
      }
    } catch (e) {
      window.setSnackbar(
        "Houve um erro ao remover este usuário, tente novamente mais tarde"
      );
    }

    setLoading(false);
  }

  return (
    <CustomModal
      maxWidth={400}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={false}
      title="Remover participante"
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container">
          <h3>Atenção!</h3>
          <h4 className="mt-1 pb-1">
            Você realmente deseja remover o participante {user?.username} do
            desafio?
          </h4>
          <label className="pt-1">
            Ao fazer isso, este participante perderá imediatamente acesso ao
            aplicativo, e seus pontos desaparecerão do ranking
          </label>
          <label className="pt-4">
            Para confirmar essa ação, digite <em>"{firstName}"</em> abaixo
          </label>
          <Material.TextField
            value={confirmText}
            onChange={(v) => setConfirmText(v.target.value)}
            placeholder={firstName}
            fullWidth
          />
          <div className="bottom-buttons-delete-member-modal mt-3">
            <MainButton
              onClick={handleRemoveUser}
              label={"Remover " + firstName + " permanentemente"}
              color="error"
              endIcon={<DeleteIcon color="error" />}
              disabled={
                firstName?.toLowerCase() !== confirmText?.toLowerCase() ||
                loading
              }
              shadow={false}
            />
          </div>{" "}
        </div>
      }
      modalClass="select-challenge-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};

const ModalGenerateLink = ({ open, setOpen, selectedGroup = null }) => {
  const { currentChallenge } = useChallenge();

  const [groupSelected, setGroupSelected] = useState(
    typeof selectedGroup === "object" ? selectedGroup?.id : ""
  );

  useEffect(() => {
    if (typeof selectedGroup === "object") {
      setGroupSelected(selectedGroup?.id);
    }
  }, [open]);

  const CopyBtn = ({ title = "", content }) => {
    return (
      <div className="group-link">
        <h5 className="group-url">{title || content}</h5>
        <MainButton
          onClick={() => {
            navigator.clipboard
              .writeText(content)
              .then(() => {
                window.setSnackbar("Link copiado com sucesso");
              })
              .catch((err) => {
                window.setSnackbar("Houve um erro ao copiar o link");
              });
          }}
          label="Copiar"
          color="primary"
          endIcon={<ContentCopyIcon color="primary" />}
          shadow={false}
        />
      </div>
    );
  };

  return (
    <CustomModal
      maxWidth={400}
      hideSecondaryButton={true}
      loading={false}
      title="Gerar link de compartilhamento"
      handleSubmit={() => setOpen(false)}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container px-1">
          <h5 className="mb-1">
            Compartilhe o link abaixo nas suas redes sociais para atrair sua
            audiência
          </h5>
          <CopyBtn content={currentChallenge?.invite_url} />
          <div className="bottom-buttons-delete-member-modal mt-3">
            <MainButton
              onClick={() => setOpen(false)}
              label="Concluir"
              color="white"
              endIcon={<CheckIcon color="primary" />}
              shadow={false}
            />
          </div>{" "}
        </div>
      }
      modalClass="select-challenge-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};

const ModalCreateChallenge = ({ challenges, onCreated }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleEvent = (event) => {
      setOpen(event.detail);
    };

    window.addEventListener("toggle_new_challenge_modal", handleEvent);

    return () => {
      window.removeEventListener("toggle_new_challenge_modal", handleEvent);
    };
  }, []);

  function handleCreated(challengeCreated) {
    setOpen(false);
    onCreated(challengeCreated);
  }

  return (
    <CustomModal
      maxWidth={600}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={false}
      title="Crie um novo desafio"
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container">
          <ChallengeConfig creationMode={true} onCreated={handleCreated} />
        </div>
      }
      modalClass="select-challenge-modal"
      bottomButtonsOrientation="horizontal"
    />
  );
};

const ChallengeConfigModal = ({
  open,
  onClose,
  onCreated,
  details = {},
  mode = "creation",
}) => {
  const { challenges, currentChallenge } = useChallenge();

  const defaultConfig =
    mode === "creation"
      ? {
          name: "Nome",
          description: "",
          duration: null,
          awards: [],
          display_awards: false,
          started_at: dayjs(new Date()),
          description_links: [],
        }
      : { ...details, started_at: dayjs(details.started_at) };

  const REF_config = useRef(defaultConfig);

  useEffect(() => {
    REF_config.current =
      mode === "creation" ? { ...defaultConfig } : { ...defaultConfig };
  }, [open]);

  const Box = ({ title, children, className = "" }) => {
    return (
      <div className={"config-section mb-3 " + (children && " pb-2")}>
        {title && (
          <>
            <div className="px-2 py-1">
              <h4 className="title">{title}</h4>
            </div>
            {children && <Material.Divider />}
          </>
        )}

        {children && <div className={"px-2 py-1 " + className}>{children}</div>}
      </div>
    );
  };

  const Header = () => (
    <div className="config-modal-header pl-3  pr-2 py-1">
      <h3>Configurar comunidade</h3>
      <Material.IconButton onClick={onClose}>
        <CloseIcon />
      </Material.IconButton>
    </div>
  );
  const Footer = () => {
    const [loading, setLoading] = useState(false);

    async function handleSubmit() {
      setLoading(true);
      const result = await handleSave();

      if (result) {
        onCreated(result.challenge_id);
      }

      setLoading(false);
    }

    return (
      <>
        {loading && <Material.LinearProgress color="primary" />}
        <div className="config-modal-footer pl-3  pr-2 py-2">
          <MainButton
            disabled={/*loading || mode !== "update"*/ true}
            shadow={false}
            variant="contained"
            color="error"
            onClick={handleDelete}
            endIcon={<DeleteIcon color="error" />}
            label={"Excluir"}
          />
          <div className="footer-main-btns">
            <MainButton
              disabled={loading}
              shadow={false}
              variant="contained"
              color="white"
              onClick={onClose}
              label={"Cancelar"}
            />
            <MainButton
              disabled={loading}
              shadow={false}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              endIcon={<SendIcon color="primary" />}
              label={"Salvar alterações"}
            />
          </div>
        </div>
      </>
    );
  };
  const FieldCounter = ({ label, counter }) => (
    <div className="field-counter">
      <small>{label}</small>
      <small>{counter}</small>
    </div>
  );

  async function handleSave() {
    try {
      const isInUpdateMode = mode === "update";

      console.log(REF_config);

      const valid = handleValidate();

      if (!valid) return;

      const conf = REF_config.current;

      let payload = { ...REF_config.current };

      if (payload.started_at) {
        payload.started_at = dayjs(payload.started_at).format(
          "YYYY-MM-DD hh:mm:ss"
        );
      }

      if (isInUpdateMode) {
        payload.id = conf.id;
      }

      const { data } = await api[isInUpdateMode ? "patch" : "post"](
        "challenge",
        { ...payload }
      );

      if (data?.success) {
        window.setSnackbar(
          isInUpdateMode
            ? "Comunidade atualizada com sucesso"
            : "Comunidade criada com sucesso"
        );
        return {
          created: true,
          challenge_id: data.challenge_id || conf.id,
        };
      }

      window.setSnackbar(
        "Houve um erro inesperado ao criar esta comunidade, confira os valores inseridos, e tente novamente"
      );

      return false;
    } catch (e) {
      console.log(e);
      window.setSnackbar(
        "Houve um erro ao salvar a comunidade, tente novamente"
      );
    }

    function handleValidate() {
      console.log(REF_config.current);
      try {
        //Validações do campo "name"
        if (!REF_config.current.name) throwError("Insira um nome válido");
        if (REF_config.current.name.length < 3)
          throwError("O nome precisa ter mais de 3 caracteres");
        if (REF_config.current.name.length > 25)
          throwError("O nome deve ter menos do que 25 caracteres");

        //Validações do campo "description"
        if (REF_config.current.description?.length > 250)
          throwError("A descrição deve ter menos do que 250 caracteres");

        return true;
      } catch (e) {
        window.setSnackbar(e.message);
      }

      function throwError(msg) {
        throw new Error(msg);
      }
    }
  }
  async function handleDelete() {
    window.openConfirm({
      title: "Remover produto",
      headline: "Atenção!",
      subtitle:
        'Você realmente deseja remover permanentemente o produto "' +
        REF_config.current.name +
        '"?',
      buttons: [
        {
          text: "Apagar permanentemente",
          onClick: handleExecuteDelete,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Manter produto",
          variant: "text",
        },
      ],
    });

    async function handleExecuteDelete() {
      try {
        const { data } = await api.delete(
          "/bank/products?id=" + REF_config.current.id
        );

        if (data.success) {
          window.setSnackbar("Produto deletado com sucesso");
          window.loadProducts();
          onClose();
        } else {
          window.setSnackbar(
            "Houve um erro ao apagar este produto, tente novamente em alguns minutos"
          );
        }

        console.log("Deletion result", data);
      } catch (e) {
        window.setSnackbar(
          "Houve um erro ao apagar este produto, tente novamente mais tarde"
        );
      }
    }
  }

  const GeneralConfig = () => {
    const [image, setImage] = useState(
      REF_config.current.banner_base64 ||
        REF_config.current.banner_url ||
        REF_config.current.banner
    );
    const [name, setName] = useState(REF_config.current.name);
    const [description, setDescription] = useState(
      REF_config.current.description
    );

    return (
      <Box title="Configurações gerais">
        <div className="config-row" style={{ alignItems: "flex-start" }}>
          <div className="add-banner-btn">
            <ImageImportTool
              size={38}
              src={image}
              onLoaded={(imageBase64) => {
                REF_config.current.banner_base64 = imageBase64;
                setImage(imageBase64);
              }}
              title="Redimensionar banner da comunidade"
            />
            {!image && <small>Banner </small>}
          </div>

          <Material.TextField
            type="text"
            fullWidth
            placeholder="Nome da comunidade"
            error={name?.length > 25}
            value={name}
            onInput={(v) => {
              REF_config.current.name = v.target.value;
              setName(v.target.value);
            }}
            helperText={
              <FieldCounter
                label="Insira o nome da comunidade"
                counter={`${name?.length || 0}/25`}
              />
            }
          />
        </div>

        <Material.TextField
          className="mt-1"
          multiline
          type="text"
          fullWidth
          value={description}
          placeholder="Descrição (opcional)"
          error={description?.length > 250}
          onInput={(v) => {
            REF_config.current.description = v.target.value;
            setDescription(v.target.value);
          }}
          helperText={
            <FieldCounter
              label="Adicione uma descrição detalhada e inspiradora para sua comunidade"
              counter={`${description?.length || 0}/250`}
            />
          }
        />
      </Box>
    );
  };
  const DescriptionLinks = () => {
    const [links, setLinks] = useState(
      REF_config.current.description_links || []
    );

    const LinkInfo = ({ data, index }) => {
      const [title, setTitle] = useState(data.title);
      const [link, setLink] = useState(data.link);

      return (
        <div className="link-info-block mt-2">
          <Material.TextField
            className={"counter-input mt-2"}
            value={title}
            onInput={(e) => {
              const linkCopy = [...links];
              linkCopy[index].title = e.target.value;
              REF_config.current.description_links = [...linkCopy];
              setTitle(e.target.value);
            }}
            color="primary"
            label="Título do link"
            InputLabelProps={{ shrink: true }}
            placeholder="O título do link será o texto do botão no app"
            error={title?.length > 25}
            helperText={"" + (title?.length || 0) + "/25"}
            fullWidth
          />
          <Material.TextField
            className={"counter-input mt-1"}
            value={link}
            onInput={(e) => {
              const value = e.target.value;
              const linkCopy = [...links];
              linkCopy[index].link = value;
              REF_config.current.description_links = [...linkCopy];
              setLink(value);
            }}
            InputProps={{
              startAdornment: (
                <Material.InputAdornment position="start">
                  <label>https://</label>
                </Material.InputAdornment>
              ),
            }}
            color="primary"
            label="Link"
            fullWidth
          />
          <Material.IconButton
            onClick={() => {
              const linkCopy = [...links];
              linkCopy.splice(index, 1);
              REF_config.current.description_links = [...linkCopy];
              setLinks([...linkCopy]);
            }}
            className="delete-link-btn"
          >
            <DeleteIcon color="error" />
          </Material.IconButton>
        </div>
      );
    };

    const linksElm =
      links?.length > 0 ? (
        <>
          {links?.map((linkInfo, i) => (
            <LinkInfo data={linkInfo} key={i} index={i} />
          ))}
        </>
      ) : null;

    return (
      <Box
        title={
          <div className="config-row">
            <h4 className="title" style={{ flexGrow: 1 }}>
              Links na descrição
            </h4>
            <MainButton
              color="white"
              onClick={() => {
                const linksCopy = [...links];
                linksCopy.push({ title: "", link: "" });
                REF_config.current.description_links = [...linksCopy];
                setLinks([...linksCopy]);
              }}
              small
              disabled={links?.length >= 3}
              endIcon={<AddIcon />}
              label="Adicionar link"
            />
          </div>
        }
        children={linksElm}
      />
    );
  };
  const Expiration = () => {
    const [duration, setDuration] = useState(REF_config.current.duration);
    const [startAt, setStartAt] = useState(REF_config.current.started_at);
    const [enabled, setEnabled] = useState(!!REF_config.current.duration);

    useEffect(() => {
      REF_config.current.duration = duration;
    }, [duration]);
    useEffect(() => {
      REF_config.current.started_at = startAt;
    }, [startAt]);
    useEffect(() => {
      if (!enabled) {
        setDuration(null);
        setStartAt(null);
      } else {
        setStartAt(dayjs(new Date()));
        setDuration(30);
      }
    }, [enabled]);

    const configChildren = enabled ? (
      <>
        <Material.Stack
          spacing={2}
          direction="row"
          alignItems="center"
          className="px-2 mb-1 mt-2"
        >
          <Material.Slider
            color="primary"
            aria-label="Volume"
            value={duration}
            onChange={(v) => {
              setDuration(v.target.value);
            }}
            min={7}
            max={365}
          />

          <Material.Typography
            variant="h5"
            style={{
              textWrap: "nowrap",
            }}
          >
            {duration} dias
          </Material.Typography>
        </Material.Stack>
        <div className="durations-row pb-2">
          <MainButton
            onClick={() => setDuration(7)}
            label="7 dias"
            color={duration === 7 ? "primary" : "white"}
            shadow={false}
          />
          <MainButton
            onClick={() => setDuration(15)}
            label="15 dias"
            color={duration === 15 ? "primary" : "white"}
            shadow={false}
          />
          <MainButton
            onClick={() => setDuration(21)}
            label="21 dias"
            color={duration === 21 ? "primary" : "white"}
            shadow={false}
          />
          <MainButton
            onClick={() => setDuration(30)}
            label="30 dias"
            color={duration === 30 ? "primary" : "white"}
            shadow={false}
          />
          <MainButton
            onClick={() => setDuration(60)}
            label="60 dias"
            color={duration === 60 ? "primary" : "white"}
            shadow={false}
          />
        </div>

        {duration && (
          <>
            <Material.Divider className="mt-1" />
            <h4 className="mt-2">Data de início do desafio:</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                size="small"
                value={startAt}
                onChange={(v) => setStartAt(v)}
                id="calendar"
                color="primary"
                showDaysOutsideCurrentMonth
              />
            </LocalizationProvider>
          </>
        )}
      </>
    ) : null;

    return (
      <Box
        title={
          <div className="config-row" style={{ padding: "2px 0px" }}>
            <h4 className="title" style={{ flexGrow: 1 }}>
              Duração da comunidade
            </h4>
            {!enabled && (
              <span>
                <i>(desativada)</i>
              </span>
            )}
            <Material.Switch
              checked={enabled}
              onChange={(v) => {
                REF_config.current.display_awards = v.target.checked;
                setEnabled(v.target.checked);
              }}
              defaultChecked
              color="primary"
            />
          </div>
        }
        children={configChildren}
      />
    );
  };
  const Awards = () => {
    const [awards, setAwards] = useState(REF_config.current.awards);

    useEffect(() => {
      REF_config.current.awards = [...awards];
    }, [awards]);

    function handleTitleInput(value, i) {
      const awardsCopy = [...awards];
      awardsCopy[i].text = value;
      setAwards([...awardsCopy]);
    }
    function handleAddBanner(image, i) {
      const awardsCopy = [...awards];
      awardsCopy[i].banner = image;
      setAwards([...awardsCopy]);
    }
    function handleRemove(i) {
      const awardsCopy = [...awards];
      awardsCopy.splice(i, 1);
      setAwards([...awardsCopy]);
    }
    function handleAddAward() {
      const awardsCopy = [...awards];
      awardsCopy.push({
        banner: "",
        text: "",
      });
      setAwards([...awardsCopy]);
    }

    const awardsChildren =
      awards?.length > 0 ? (
        <>
          {awards.map((award, i) => {
            return (
              <div className="award-row mt-3" key={i}>
                <ImageImportTool
                  size={50}
                  key={Math.random()}
                  src={award.banner}
                  onLoaded={(imageBase64) => handleAddBanner(imageBase64, i)}
                  title="Redimensionar foto do prêmio"
                />
                <Material.TextField
                  placeholder="Insira o nome da premiação"
                  className={"counter-input fade delay-1"}
                  value={award.text || ""}
                  onInput={(e) => handleTitleInput(e.target.value, i)}
                  color="primary"
                  label="Nome do prêmio"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <Material.IconButton
                  onClick={() => handleRemove(i)}
                  aria-label="delete"
                >
                  <DeleteIcon />
                </Material.IconButton>
              </div>
            );
          })}
        </>
      ) : null;

    return (
      <Box
        title={
          <div className="config-row">
            <h4 className="title" style={{ flexGrow: 1 }}>
              Premiações
            </h4>
            <MainButton
              color="white"
              onClick={handleAddAward}
              small
              endIcon={<AddIcon />}
              label="Adicionar prêmio"
            />
          </div>
        }
        children={awardsChildren}
      />
    );
  };

  return (
    <Material.Drawer
      className="configure-product-modal"
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Header />

      <div className="configs-body px-3 pb-2 pt-5">
        <GeneralConfig />

        <DescriptionLinks />

        <Expiration />

        <Awards />
      </div>

      <Footer />
    </Material.Drawer>
  );
};

export { ChallengeConfigModal };
